module.exports = __webpack_public_path__ + "assets/img/kupa-helmet.11cb52ab.png";